unable to read source [project]/packages/src/components/compound/ratingSelectionForm/RatingRow.tsx